<template>
  <div class="form">
    <Input
      prefix="ios-contact"
      placeholder="请输入你的姓名"
      size="large"
      v-model="username"
      style="width: 100%;margin-bottom:10px;"
    />
    <Input
      prefix="ios-call"
      placeholder="请输入你的电话"
      size="large"
      v-model="mobile"
      type="tel"
      style="width: 100%;margin-bottom:10px;"
    />
    <RadioGroup v-model="radio2" style="margin-bottom:10px;">
      <Radio label="西点"></Radio>
      <Radio label="西餐"></Radio>
      <Radio label="咖啡"></Radio>
      <Radio label="调酒"></Radio>
    </RadioGroup>
    <Button
      type="warning"
      size="large"
      :style="{ background: bag, color: color, height: '41px' }"
      :loading="loading"
      v-on:click="send"
      long
      >{{ buttonWords }}</Button
    >
  </div>
</template>

<script>
import { Toast } from 'vant';
export default {
  data() {
    return {
      username: '',
      mobile: '',
      loading: false,
      buttonWords: this.words,
      radio2: '西点',
    };
  },
  props: {
    color: {
      type: String,
      default: '',
    },
    bag: {
      type: String,
      default: '',
    },
    words: {
      type: String,
      default: '',
    },
  },
  methods: {
    send() {
      this.buttonWords = '';
      this.loading = true;
      let valid_rule = /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;
      console.log(this.$route.path);
      setTimeout(() => {
        this.loading = false;
        this.buttonWords = '点击报名';
      }, 1500);
      if (this.username == '' || this.mobile == '') {
        Toast.fail('请完整填写表单');
        return false;
      } else if (!valid_rule.test(this.mobile)) {
        Toast.fail('手机号码错误');
        return false;
      } else {
        this.$axios
          .get('http://api.cdomick.com/index.php/api/form', {
            params: {
              name: this.username,
              mobile: this.mobile,
              c_like: this.radio2,
              laiyuan: this.$route.path,
            },
          })
          .then(function(response) {
            console.log(response);
            if (response.data.code == 1) {
              Toast.success(response.data.msg);
            } else {
              Toast.success('成功');
            }
          })
          .catch(function(error) {
            console.log(error);
            Toast.success('成功');
            this.loading = false;
            this.buttonWords = '点击报名';
          });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.form {
  width: 100%;
  text-align: center;
  padding: 10px;
}
/deep/ .ivu-input:hover {
  color: #be0000;
  border: 1px solid #be0000;
}
/deep/ .ivu-radio-inner:after {
  background: #be0000;
}
/deep/ .ivu-radio-checked:hover .ivu-radio-inner {
  border-color: #be0000;
}
/deep/.ivu-radio-checked .ivu-radio-inner {
  border-color: #be0000;
}
/deep/ .ivu-input-wrapper-large .ivu-input-prefix i,
.ivu-input-wrapper-large .ivu-input-suffix i {
  line-height: 45px;
}
/deep/ .ivu-input-large {
  height: 45px;
}
/deep/ .ivu-input-wrapper-large .ivu-input-prefix i,
.ivu-input-wrapper-large .ivu-input-suffix i {
  color: #be0000;
}
/deep/ .ivu-btn-warning {
  border-color: #fff;
}
</style>
